module.exports = __webpack_public_path__ + "img/location.cfc4da78.png";